<template>
	<div class="move_box" :class="this.$store.state.moveboxshow?'active':''" >
		<div class="movebox_title">
			<el-tabs v-model="$store.state.editableTabsValue2" type="card" closable @tab-remove="removeTab" @tab-click="$store.state.moveboxshow = false">
				<el-tab-pane v-for="item in $store.state.editableTabs2" :key="item.name" :label="item.title" :name="item.name" v-loading="$store.state.iframe_loading">
					<iframe :ref="'iframepage'+item.name" :src="item.url" :style="{height:winh +'px'}" style="width: 100%;border: 1px solid #eee;"></iframe>
				</el-tab-pane>
			</el-tabs>
		</div>
		<el-button class="moveboxoutbtn" type="text" size="mini" @click="$store.state.moveboxshow = true" >返回主菜单<i class="el-icon-d-arrow-right"></i></el-button>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tabIndex: 2,
				winh: window.innerHeight - 60,
				parentDate:"123123"
			};
		},
		mounted: function(){
			// this.getData();
		},
		watch:{
			'$store.state.editableTabs2'(n,o){
				console.log(n);
				if(n.length == 0){
					this.$store.state.moveboxshow = true;
				}
			}
		},
		methods: {

			// getData:function(pid){
			// 	console.log("54545656565456");
			// 	let iframe = document.getElementById('iframepage'+pid).contentWindow;
			// 	console.log(iframe);
			// 	iframe.postMessage("666666666","*");
			// },

			removeTab: function(targetName) {
				let tabs = this.$store.state.editableTabs2;
				let activeName = this.$store.state.editableTabsValue2;
				if (activeName === targetName) {
					tabs.forEach((tab, index) => {
						if (tab.name === targetName) {
							let nextTab = tabs[index + 1] || tabs[index - 1];
							if (nextTab) {
								activeName = nextTab.name;
							}
						}
					});
				}
				this.$store.state.editableTabsValue2 = activeName;
				this.$store.state.editableTabs2 = tabs.filter(tab => tab.name !== targetName);
			},
			
		},
	}
</script>

<style>
	.move_box {
		width: 100%;
		height: 100%;
		position: fixed;
		background-color: #fff;
		left: 0;
		top: 0;
		z-index: 100;
		transition: all .3s ease-in-out;
		box-shadow: 0 0 5px #ccc;
	}

	.move_box.active {
		top: calc(100% - 40px);
	}
	.moveboxoutbtn{
		position: absolute;
		right: 10px;
		top: 7px;
	}
</style>



// WEBPACK FOOTER //
// src/components/contentbox_ban.vue